import { DirectiveBinding } from 'vue';
import { pageScrollToTop } from './state';

interface DirectiveElement extends Element {
    scrollTop: number;
}

export default {
    name: 'scroll-restoration',
    setup() {
        return {
            pageScrollToTop,
        };
    },
    mounted(el: DirectiveElement, binding: DirectiveBinding) {
        const fullPath = binding.value;

        if (pageScrollToTop.value?.[fullPath] && el) {
            el.scrollTop = pageScrollToTop.value?.[fullPath] ?? 0;
            pageScrollToTop.value[fullPath] = undefined;
        }
    },
    beforeUnmount(el: Element, binding: DirectiveBinding) {
        const fullPath = binding.value;

        if (fullPath && el) {
            pageScrollToTop.value[fullPath as string] = el.scrollTop;
        }
    },
};
